<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Csl1AH/tc-custom/9780830894468.jpg?1696025388620" alt="This image is the cover for the book A Little Book for New Philosophers, Little Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Little Book for New Philosophers, Little Books
      </h1>
      <p class="bookDescription body article font2">
        <p>What's the point of studying philosophy when we have theology? Is philosophy anything more than a preparation for apologetics? Often called "theology's handmaid," philosophy has sometimes suffered from an inferiority complex in the church. Many Christians see little point in it at all. But as Paul Copan contends, it is possible to affirm theology's preeminence without diminishing the value and contribution of philosophy. In<em>A Little Book for New Philosophers</em>, Copan offers a concise introduction to the study of philosophy. Aimed at newcomers, this brief overview is both a survey of philosophy's basic aims and categories and an apology for its proper function in the life of the Christian. "By God's grace," Copan writes, "philosophy can enhance our understanding and worship of God . . . and assist us in defending the coherence of our faith in the Lord Jesus Christ."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Copan
      </h2>
      
      <p class="authorDescription body article"><p>Paul Copan (PhD, Marquette University) is the Pledger Family Chair of Philosophy and Ethics at Palm Beach Atlantic University. His books include <em>The Gospel in the Marketplace of Ideas</em>, <em>An Introduction to Biblical Ethics</em>, <em>Creation Out of Nothing</em>, <em>Did God Really Command Genocide?</em> and <em>Holy War in the Bible</em>. He previously served with Ravi Zacharias International Ministries and taught at Trinity International University in Deerfield, Illinois.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?559eed37